import React from 'react';
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from '../MenuItems';
import { useSelector } from 'react-redux';
import _ from 'lodash';


export const allowedRoutes = {
  candidate: {
    '/jobs': true,
    '/jobs/:jobId': true,
  },
};
const MenuList = () => {
    const {userType} = useSelector((state) => {
      return {
        userType: state?.auth?.user?.userType
      }
    });

    const navItems = menuItem.items.map((item) => {
      let updatedItem = _.cloneDeep(item)
      updatedItem.children  = updatedItem.children.filter(({url}) => {
          return allowedRoutes?.[userType]?.[url] || userType === "candidate";
      });
      switch (updatedItem.type) {
        case 'group':
          return <NavGroup key={updatedItem.id} item={updatedItem} />;
        default:
          return (
            <Typography key={updatedItem.id} variant="h6" color="error" align="center">
                Menu Items Error
            </Typography>
          );
      }
    });

    return (
      <>
        {navItems}
      </>
    )
};

export default MenuList;
